import { Option } from 'components/Select/types';
import { api, optionsMapper } from './Fetcher';

export const getAvailableDivisions = (): Promise<Option[]> => {
  return api
    .get('/signup/team-applications/available-options/division-types/')
    .then((res) => res.data)
    .then(optionsMapper);
};

export const getAvailableSeasons = (): Promise<Option[]> => {
  return api
    .get('/signup/team-applications/available-options/seasons/')
    .then((res) => res.data)
    .then(optionsMapper);
};

export const getNDAChecked = (application_id: string): Promise<any> => {
  return api.get(`/signup/team-applications/${application_id}/check-nda-signed/`);
};

export const postTeamRegistration = (data: FormData): Promise<any> => {
  return api.post('/signup/team-applications/', data);
};
